import Icon from '../components/Icon.vue'

Icon.register({
  'kiss-wink-heart': {
    width: 504,
    height: 512,
    paths: [
      {
        d: 'M501.1 402.5C493.1 381.7 469.6 371 448 376.6L439.6 378.8 437.3 370.4C431.4 349 410.3 333.9 388.3 337.4 363.1 341.4 347.7 366 354.3 390L377.2 472.6C378.7 477.9 384.2 481.1 389.6 479.7L472.6 458.2C496.7 451.9 510.3 426.4 501.1 402.5zM323.5 398.5C317.9 378.2 321.2 356.5 332.5 338.8 362.2 292.5 431.2 293.3 460.3 343.1 466.7 343.2 472.9 344.5 478.9 346 489.8 318.1 496 287.8 496 256 496 119 385 8 248 8S0 119 0 256 111 504 248 504C283.4 504 316.9 496.5 347.4 483.1 347.1 482.4 323.5 398.5 323.5 398.5zM168 240C150.3 240 136 225.7 136 208S150.3 176 168 176 200 190.3 200 208 185.7 240 168 240zM288 396C288 415.2 259.3 437.5 216.5 440 208 440.8 204.4 428.2 212.9 424.6L229.9 417.4C242.9 411.9 250.7 403.9 250.7 395.9S242.9 379.9 229.9 374.4L212.9 367.2C206.9 364.7 207.2 354.9 212.9 352.4L229.9 345.2C242.9 339.7 250.7 331.7 250.7 323.7S242.9 307.7 229.9 302.2L212.9 295C204.1 291.3 208.3 278.4 216.5 279.6 259.3 282.1 288 304.4 288 323.6 288 336.6 274.6 350.9 252.8 359.6 274.6 368.7 288 383 288 396zM304 217C295.7 224.4 282.4 217.4 284.2 206.2 288.2 181 318.4 164.1 344.1 164.1S400 181 404 206.2C405.7 217.3 392.7 224.5 384.2 217L374.7 208.5C359.9 195.3 328.5 195.3 313.7 208.5L304 217z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/kiss-wink-heart.js
// module id = 9P2O
// module chunks = 144